import * as React from 'react';
import AmCharts from "@amcharts/amcharts3-react";
import ReactTable from "react-table";
import 'react-table/react-table.css'
import { _ } from "@src/services/i18n";
import { classNames, css, mixin, vars, defaultProps, formatters } from '@src/services/theme';
import { Proto, Props, State } from '@src/components/Proto';
import { Box } from '@src/components';

// typing
interface LocalState extends State {
    count?: any;
}

// style
const lvars = {
    counter: 60
}
const style = css`
    ${mixin.row2}

    > .table {
    }
    > .stats {
        > article {
            padding: 20px 0;
            .iconBadge {
                ${mixin.iconBadge}
            }
        }

        .legend-pie {
            font-size: 16px;
            padding: 30px 50px 20px;
            @media screen and (max-width: 1600px) {
                padding-right: 10px;
            }
            @media screen and (max-width: 768px) {
                border-top: 1px solid #ccc;
            }
            strong{
                display: block;
                font-size: 24px;
                font-weight: 500;
                position: relative;
                &:before{
                    content: "";
                    width: 20px;
                    height: 20px;
                    background-color: #b7e021;
                    border-radius: 10px;
                    top: 3px;
                    left: -27px;
                    position: absolute;
                }
                &.arancio{
                    color: #666;
                    &:before{
                    background-color: #ff9900;
                    }
                }
                &.giallo{
                    color: #666;
                    &:before{
                    background-color: #ffcc00;
                    }
                }
                &.rosso{
                    color: #666;
                    &:before{
                    background-color: #ff0000;
                    }
                }
            }
        }
    }
`;

// component
export class TopCustomers extends Proto<Props, LocalState> {

    parseGraphData( ) {
        if (!this.state || !this.state.data) return []; 
        const { data } = this.state;
        const { piechart } = data;
        return [
            { title: _('topcustomers_graph_notok', 'Dash'), value: piechart.errors, color: vars.colors.red },
            { title: _('topcustomers_graph_warning', 'Dash'), value: piechart.warnings, color: vars.colors.orange },
            { title: _('topcustomers_graph_ok', 'Dash'), value: piechart.ok, color: vars.colors.green },
        ];
    }

	// render
	render() {
        const loading = this.loading();
        if (loading) return loading;
        const { data } = this.state;
        const { onBattery } = this.props;
        const { piechart } = data;
        const columns = [
            { Header: _('topcustomers_col_customer', 'Dash'), accessor: 'customer.name'},
            { Header: _('topcustomers_col_devices', 'Dash'), accessor: 'count_devices', className: "number"},
            { Header: _('topcustomers_col_soh', 'Dash'), id: "avg_soh", accessor: v => v.avg_soh ? `${v.avg_soh} %` : null, className: "number"},
            { Header: _('topcustomers_col_age', 'Dash'), accessor: "avg_age", className: "number"},
            { Header: _('topcustomers_col_status', 'Dash'), id: "avg_status", accessor: v => formatters.status(v.avg_status), className: "bullet"},
            { Header: _('topcustomers_col_errors', 'Dash'), id: "count_errors", accessor: v => `${v.count_errors} %`, className: "number" },
            { Header: _('topcustomers_col_warnings', 'Dash'), id: "count_warnings", accessor: v => `${v.count_warnings} %`, className: "number" },
        ];
        
        const tableProps = {
            ...defaultProps.table({
                showPagination: true,
                onClick: (item) => { if (onBattery) onBattery({id: item.battid}); }
            }),
        }

        const config = {
            "type": "pie",
            "labelsEnabled": false,
            "theme": "light",
            "titleField": "title",
            "valueField": "value",
            "labelRadius": 5,
            "colorField": "color",

            "radius": "42%",
            "innerRadius": "60%",
            "dataProvider": this.parseGraphData()
        };

		return (
            <Box title={_('topcustomers_title', 'Dash')} collapsed={false}>
                <div className={style}>
                    <section className="stats">
                        {piechart &&
                        <div className="legend-pie">
                            <div className="row">
                                <div className="col-sm-4">
                                    <strong className="rosso">{piechart.errors}</strong>
                                    {_('topcustomers_graph_notok', 'Dash')}
                                </div>
                                <div className="col-sm-4">
                                    <strong className="arancio">{piechart.warnings}</strong>
                                    {_('topcustomers_graph_warning', 'Dash')}
                                </div>
                                <div className="col-sm-4">
                                    <strong className="verde">{piechart.ok}</strong>
                                    {_('topcustomers_graph_ok', 'Dash')}
                                </div>
                            </div>
                        </div>
                        }
                        <AmCharts.React style={{ width: "100%", height: "300px" }} options={config} />
                    </section>
                    <section className="table">
                        <ReactTable
                            {...tableProps}
                            data={data.data}
                            columns={columns}
                        />
                    </section>
                </div>
            </Box>
		);
	}
}



// WEBPACK FOOTER //
// ./src/components/Dash/TopCustomers.tsx